import GlobalSettings from './GlobalSettings';
export default GlobalSettings;
